// Native Shopify forms remain usable without JavaScript.
function initialiseWildcraft(root = document) {
  const menu = root.querySelector('.menu-toggle');
  if (menu && !menu.dataset.ready) {
    menu.dataset.ready = 'true'; menu.hidden = false;
    document.documentElement.classList.add('wc-js');
    const drawer = document.getElementById(menu.getAttribute('aria-controls'));
    const controller = new AbortController();
    const options = { signal: controller.signal };
    const desktop = matchMedia('(min-width: 801px)');
    const reset = () => { menu.setAttribute('aria-expanded', 'false'); document.documentElement.classList.remove('wc-menu-open'); };
    const close = () => { if (drawer.open) drawer.close(); reset(); };
    menu.addEventListener('click', () => {
      if (drawer.open) { close(); return; }
      drawer.showModal();
      menu.setAttribute('aria-expanded', 'true');
      document.documentElement.classList.add('wc-menu-open');
    }, options);
    drawer.querySelector('[data-close-menu]').addEventListener('click', close, options);
    drawer.addEventListener('close', reset, options);
    drawer.addEventListener('click', event => {
      if (event.target.closest('a')) { close(); return; }
      if (event.target !== drawer) return;
      const rect = drawer.getBoundingClientRect();
      if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) close();
    }, options);
    desktop.addEventListener('change', () => {
      if (desktop.matches && drawer.open) { close(); document.querySelector('#navigation a')?.focus(); }
    }, options);
    document.addEventListener('shopify:section:unload', event => {
      if (event.target.contains(menu)) { close(); controller.abort(); }
    }, options);
  }
  root.querySelectorAll('.region-form').forEach(form => {
    if (form.dataset.enhanced) return;
    const select = form.querySelector('[name="country_code"]');
    const initialCountry = select.querySelector('option[selected]')?.value || select.value;
    const controller = new AbortController();
    const options = { signal: controller.signal };
    form.dataset.enhanced = 'true';
    form.querySelector('.region-hint').textContent = 'Changing country updates prices and reloads this page.';
    const applyCountry = () => {
      if (select.value === initialCountry || form.dataset.submitting) return;
      const returnTo = form.querySelector('[name="return_to"]');
      if (returnTo) returnTo.value = location.pathname + location.search + location.hash;
      form.dataset.submitting = 'true';
      form.setAttribute('aria-busy', 'true');
      form.requestSubmit();
    };
    select.addEventListener('change', applyCountry, options);
    if (select.value !== initialCountry) applyCountry();
    window.addEventListener('pageshow', event => {
      // A cached page from before a market change contains prices from the old market.
      if (event.persisted && form.dataset.submitting) { location.reload(); return; }
      delete form.dataset.submitting; form.removeAttribute('aria-busy');
    }, options);
    document.addEventListener('shopify:section:unload', event => {
      if (event.target.contains(form)) controller.abort();
    }, options);
  });
  root.querySelectorAll('.product-form').forEach(form => {
    if (form.dataset.ready) return;
    form.dataset.ready = 'true';
    const quantity = form.querySelector('[name="quantity"]');
    const section = form.closest('[data-product-section]');
    if (!quantity || !section) return;
    const image = section.querySelector('#ProductImage');
    const normalise = () => {
      const min = Number(quantity.min) || 1, step = Number(quantity.step) || 1;
      const max = quantity.max ? Number(quantity.max) : Infinity;
      const value = Math.max(min, Math.min(max, Number(quantity.value) || min));
      quantity.value = String(min + Math.floor((value - min) / step) * step);
      form.querySelector('[data-quantity="-1"]').disabled = Number(quantity.value) <= min;
      form.querySelector('[data-quantity="1"]').disabled = Number(quantity.value) >= max;
    };
    const changeImage = (src, alt) => {
      if (!image || !src) return;
      if (image.src !== new URL(src, location.href).href) { image.removeAttribute('srcset'); image.src = src; }
      image.alt = alt || '';
    };
    const syncVariant = (radio, updateUrl = false) => {
      if (!radio) return;
      section.querySelector('[data-price]').textContent = radio.dataset.priceLabel;
      const compare = section.querySelector('[data-compare-price]');
      compare.textContent = radio.dataset.compareLabel; compare.hidden = !radio.dataset.compareLabel;
      const button = form.querySelector('[name="add"]');
      button.disabled = radio.dataset.available !== 'true'; button.textContent = button.disabled ? 'Sold out' : 'Add to cart';
      quantity.min = radio.dataset.min; quantity.step = radio.dataset.step; quantity.max = radio.dataset.max || '';
      normalise(); changeImage(radio.dataset.image, radio.dataset.alt);
      if (updateUrl) { const url = new URL(location.href); url.searchParams.set('variant', radio.value); history.replaceState({}, '', url); }
    };
    form.querySelectorAll('[name="id"]').forEach(radio => radio.addEventListener('change', () => syncVariant(radio, true)));
    syncVariant(form.querySelector('[name="id"]:checked'));
    form.querySelectorAll('[data-quantity]').forEach(button => button.addEventListener('click', () => {
      quantity.value = String(Number(quantity.value) + Number(button.dataset.quantity) * (Number(quantity.step) || 1)); normalise();
    }));
    quantity.addEventListener('change', normalise); normalise();
    section.querySelectorAll('[data-gallery-image]').forEach(link => link.addEventListener('click', event => { event.preventDefault(); changeImage(link.dataset.galleryImage, link.dataset.galleryAlt); }));
  });
}
function accountForPreviewBar() {
  if (!window.Shopify?.theme || window.Shopify.theme.role === 'main') return;
  // Shopify's draft toolbar overlays the viewport. Reserve its measured height
  // so a short page's footer meets the toolbar without hiding its bottom links.
  let bar = null;
  const update = () => {
    const visible = bar?.isConnected && getComputedStyle(bar).visibility !== 'hidden';
    const height = visible ? Math.min(innerHeight, bar.getBoundingClientRect().height) : 0;
    document.documentElement.style.setProperty('--wc-preview-bar-height', `${height}px`);
  };
  const sizeObserver = new ResizeObserver(update);
  const stateObserver = new MutationObserver(update);
  const findBar = () => {
    const next = document.getElementById('PBarNextFrameWrapper');
    if (next !== bar) {
      sizeObserver.disconnect(); stateObserver.disconnect(); bar = next;
      if (bar) {
        sizeObserver.observe(bar);
        stateObserver.observe(bar, { attributes: true, attributeFilter: ['style', 'class', 'hidden'] });
      }
    }
    update();
  };
  new MutationObserver(findBar).observe(document.body, { childList: true });
  window.addEventListener('resize', update);
  findBar();
}
initialiseWildcraft();
accountForPreviewBar();
document.addEventListener('shopify:section:load', event => initialiseWildcraft(event.target));
